import { render, staticRenderFns } from "./ArticlesTitle.vue?vue&type=template&id=4af4d72b&scoped=true&"
import script from "./ArticlesTitle.vue?vue&type=script&lang=js&"
export * from "./ArticlesTitle.vue?vue&type=script&lang=js&"
import style0 from "./ArticlesTitle.vue?vue&type=style&index=0&id=4af4d72b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af4d72b",
  null
  
)

export default component.exports